
export const generateMessageObject = (key: string): { id: string; defaultMessage: string } => ({
  id: key,
  defaultMessage: key,
});
